import { useMutation } from "react-query";
import { Fragment, useEffect, useReducer, useState } from "react";

import consumeProductsReducer, { ACTION_TYPES } from "./consumeProductsReducer";
import Modal from "../../../shared/components/Modal";
import Form from "./../../../shared/components/Form";
import Button from "../../../shared/components/Button";
import ResourceLink from "../../../shared/components/ResourceLink";
import { updateProductionOrderComponentsDetails } from "../../../../../services/Production/productionOrderClient";
import { toast } from "react-toastify";

export default function ConsumeProductsModal({
  isShown,
  setIsShown,
  products,
  productionOrderId,
}) {
  const { mutate, isLoading, isError, isSuccess } = useMutation({
    mutationFn: updateProductionOrderComponentsDetails,
    mutationKey: [productionOrderId],
  });

  useEffect(() => {
    if (isError) toast("There was an error", { type: "error" });
    if (isSuccess) {
      toast("Composants mis à jour avec succès", { type: "success" });
      setIsShown(false);
    }
  }, [isError, isSuccess, setIsShown]);

  const [selectedProducts, dispatch] = useReducer(
    consumeProductsReducer,
    products.map(({ id }) => ({ id, selected: false, quantity: 0 }))
  );

  const handleSubmit = (selectedProducts) => {
    mutate({
      productionOrderId: productionOrderId,
      data: selectedProducts.filter((product) => product.selected),
    });
  };

  const handleProductSelect = (product) => (e) => {
    if (e.target.checked)
      dispatch({
        payload: product.id,
        type: ACTION_TYPES.SELECT_PRODUCT,
      });
    else
      dispatch({
        payload: product.id,
        type: ACTION_TYPES.UNSELECT_PRODUCT,
      });
  };
  const handleQteChange = (product) => (e) => {
    dispatch({
      type: ACTION_TYPES.SET_PRODUCT_QTE,
      payload: { consumedQte: +e.target.value, productId: product.id },
    });
  };

  return (
    <Modal size="md" isShown={isShown} onClose={() => setIsShown(false)}>
      <Modal.Header>
        <Modal.Title title="Sélectionner les produits a consommer" />
      </Modal.Header>

      <Modal.Body>
        <div style={{ maxHeight: 200, overflow: "auto", paddingRight: 16 }}>
          {products && products.length && (
            <MultiSelectProducts
              products={products}
              onSelectProduct={handleProductSelect}
              onQteChange={handleQteChange}
            />
          )}
        </div>
      </Modal.Body>

      <div
        style={{
          width: "100%",
          position: "sticky",
          bottom: 0,
          background: "white",
        }}
      >
        <Modal.Footer>
          <Button
            isLoading={isLoading}
            onClick={() => handleSubmit(selectedProducts)}
            className="ml-auto"
          >
            Sauvegarder
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
}

function MultiSelectProducts({ products, onSelectProduct, onQteChange }) {
  return (
    <Fragment>
      {products.map((product, index) => (
        <Fragment key={product.id}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div className="icheck-primary d-inline">
              <input
                onChange={onSelectProduct(product)}
                ref={(node) =>
                  node?.style.setProperty("position", "static", "important")
                }
                type="checkbox"
                id={`checkbox-${index}`}
              />

              <label htmlFor={`checkbox-${index}`}></label>
            </div>
            <ResourceLink
              to={`/products/${product.id}`}
              resourceIdentifier={product.productCode}
              resourceName={product.name}
            />
            <label style={{ fontSize: ".9rem" }}>Qte:</label>
            <Form.Input
              onChange={onQteChange(product)}
              style={{ width: "60px" }}
              className="form-control ml-2"
              type="number"
            />
          </div>
          {index !== products.length - 1 && <hr style={{ margin: 0 }} />}
        </Fragment>
      ))}
    </Fragment>
  );
}
